import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-popover", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("popover-panel", "popover-panel"),
            componentTag: "ux-popover-panel",
            performActions: async (page) => {
                await page.waitForSelector(".ux-popover__overlay--opened");
                await page.setViewport({ height: 300, width: 375 });
                await page.waitForTimeout(1000);
            },
            pageHeight: 300,
            pageWidth: 450,
        });
    });
});
